module.exports = __webpack_public_path__ + "bff66eabff86c866b7fbd983aac975dd.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/notFound/forbidden.png
// module id = 1243
// module chunks = 0